<template>
  <div :class="['Form-field', className]">
    <label
      v-if="label"
      :for="id"
      class="Form-label"
    >
      {{ label }}
      <span
        v-if="required"
        class="Form-required"
      >
        *
      </span>
    </label>
    <div
      :class="['Form-inputBox', icon, {'Has-icon':hasIcon, 'Form--valid': !error.invalid && error.dirty || !error.invalid && activeValidation, 'Form--error': error.invalid && error.dirty || error.invalid && activeValidation}]"
    >
      <input
        :id="id"
        :type="inputType"
        :placeholder="placeholder"
        :autocomplete="autocomplete"
        :class="['Form-input', {'form-valid': !error.invalid && error.dirty || !error.invalid && activeValidation}]"
        :name="name"
        :disabled="disabled"
        :value="modelValue"
        v-bind="$attrs"
        @keypress="handleKeypress"
        @blur="isBlurred = true;"
        @input="handler"
      >
      <a
        v-if="clearable && modelValue"
        class="Form-clearable"
        @click.prevent="clearField"
      >
        <span class="far fa-times" />
      </a>
    </div>
    <error-messages
      :errors="error.errors"
      :is-blurred="isBlurred"
      :manual-validate="manualValidate"
    />
    <hint-message
      :hint="hint"
    />
  </div>
</template>

<script>
/* eslint no-underscore-dangle: 0 */
import formInputMixin from '../../mixins/form-input-mixin';

export default {
  name: 'RmpInput',

  mixins: [formInputMixin],

  props: {
    modelValue: {
      default: null,
      type: [String, Number, Boolean],
    },
    id: {
      type: String,
      default() {
        return `input-id-${Math.floor(Math.random() * 1000) * 5}`;
      },
    },
    hasIcon: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: 'on',
    },
    manualValidate: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: null,
    },
    inputType: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: null,
    },
    activeValidation: {
      type: Boolean,
      default: false,
    },
    hint: {
      default: null,
      type: Object,
    },
    error: {
      default() {
        return {};
      },
      type: Object,
    },
    valid: {
      default: false,
      type: Boolean,
    },
    label: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue', 'cleared', 'input', 'change'],

  data() {
    return {
      isBlurred: false,
    };
  },

  methods: {
    handleKeypress(event) {
      this.serverValidation = '';

      // fix issue with safari allowing letters and symbols when using type=number
      if (this.inputType === 'number') {
        const charCode = (event.which) ? event.which : event.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          event.preventDefault();
        }
      }

      return true;
    },
    handler(event) {
      this.$emit('update:modelValue', event.target.value);
      this.$emit('input', event.target.value);
      this.$emit('change', event.target.value);
    },
    clearField(event) {
      this.$emit('update:modelValue', event.target.value = '');
      this.$emit('cleared');
    },
  },

};
</script>
